__turbopack_context__.v({
  "avatar": "ytWeFa_avatar",
  "card": "ytWeFa_card",
  "content": "ytWeFa_content",
  "details": "ytWeFa_details",
  "foot": "ytWeFa_foot",
  "kindBadge": "ytWeFa_kindBadge",
  "tag": "ytWeFa_tag",
  "title": "ytWeFa_title",
  "titleRow": "ytWeFa_titleRow",
});
